import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CTABanner = ({ title, sub, testPrefix = "cta" }) => (
  <section className="relative overflow-hidden" data-testid={`${testPrefix}-banner`}>
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(50% 60% at 50% 100%, rgba(255,77,0,0.16), transparent 70%)" }}
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 text-center">
      <Reveal>
        <h2 className="font-syne text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white max-w-4xl mx-auto">
          {title}
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-6 text-base sm:text-lg text-gray-400 max-w-2xl mx-auto">{sub}</p>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to="/contact"
            data-testid={`${testPrefix}-book-audit`}
            className="inline-flex justify-center items-center gap-2 rounded-full bg-flame px-8 py-4 font-semibold text-white transition-all hover:bg-flame-hover hover:scale-[1.02]"
          >
            Book Strategic Audit
            <ArrowUpRight className="h-5 w-5" />
          </Link>
          <a
            href="tel:+13075007253"
            data-testid={`${testPrefix}-call-phone`}
            className="inline-flex justify-center items-center gap-2 rounded-full border border-white/20 px-8 py-4 font-semibold text-white transition-colors hover:border-flame hover:text-flame"
          >
            <Phone className="h-5 w-5" />
            +1 (307) 500-7253
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTABanner;
